import { render, staticRenderFns } from "./StateArchived.vue?vue&type=template&id=1375ffef&scoped=true&"
import script from "./StateArchived.vue?vue&type=script&lang=js&"
export * from "./StateArchived.vue?vue&type=script&lang=js&"
import style0 from "./StateArchived.vue?vue&type=style&index=0&id=1375ffef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1375ffef",
  null
  
)

export default component.exports